
export const ROUTES = {
  SIGN_IN_REGISTER: {
    fullPath: '/signinregister',
    path: '/signinregister',
    name: 'signinregister'
  },
  MY_ORGANIZATION: {
    fullPath: '/myorganization',
    path: '/myorganization',
    name: 'myorganization'
  },
  REGISTRATION: {
    fullPath: '/registration',
    path: '/registration',
    name: 'registration'
  },
  ORGANIZATION_REGISTRATION: {
    fullPath: '/organizationregistration',
    path: '/organizationregistration',
    name: 'org-registration'
  },
  HOME: {
    fullPath: '/',
    path: '/',
    name: 'home'
  },
  HCE_REGISTRATION: {
    fullPath: '/organizationregistration/:orgType',
    path: '/organizationregistration/:orgType',
    name: 'hce-registration'
  },
  CONTACT_REGISTRATION: {
    fullPath: '/contactregistration/:organizationId',
    path: '/contactregistration/:organizationId',
    name: 'contactregistration'
  },
  ANNUAL_REPORTS: {
    fullPath: '/annualreports',
    path: '/annualreports',
    name: 'annualreports'
  },
  CONVERSATION: {
    fullPath: '/conversations/conversation',
    path: '/conversations/conversation',
    name: 'conversation'
  },
  CONVERSATIONS: {
    fullPath: '/conversations',
    path: '/conversations',
    name: 'conversations'
  },
  NEW_CONVERSATION: {
    fullPath: '/conversations/new',
    path: '/conversations/new',
    name: 'newconversation'
  },
  NEW_GENERAL_NOTICE: {
    fullPath: '/conversations/newnotice',
    path: '/conversations/newnotice',
    name: 'newnotice'
  },
  VIEW_REPORTING_EXCEPTION: {
    fullPath: '/reportingexception/exception',
    path: '/reportingexception/exception',
    name: 'viewreportingexception'
  },
  UNAUTHORIZED: {
    fullPath: '/unauthorized',
    path: '/unauthorized',
    name: 'unauthorized'
  },
  NOT_FOUND: {
    fullPath: '/:catchAll(.*)',
    path: '/:catchAll(.*)',
    name: 'notfound'
  }
};

export const HCE_ROUTES = {
  TRANSACTIONS: {
    fullPath: '/hce/transactions',
    path: 'transactions',
    name: 'hcetransactions'
  },
  EDIT_TRANSACTION: {
    fullPath: '/hce/transaction/:id',
    path: 'transaction/:id',
    name: 'edittransaction'
  }
};


const PROGRAM_BASE_PATH = '/program';

export const PROGRAM_ROUTES = {
  ORGANIZATIONS: {
    fullPath: `${PROGRAM_BASE_PATH}/organizations`,
    path: 'organizations',
    name: 'organizations'
  },
  REGISTRATION_APPROVALS: {
    fullPath: `${PROGRAM_BASE_PATH}/registrationapprovals`,
    path: 'registrationapprovals',
    name: 'registrationapprovals'
  },
  ORGANIZATION: {
    fullPath: `${PROGRAM_BASE_PATH}/organization/:id`,
    path: 'organization/:id',
    name: 'organization'
  },
  MY_DEPARTMENT: {
    fullPath: `${PROGRAM_BASE_PATH}/mydepartment`,
    path: 'mydepartment',
    name: 'mydepartment'
  },
  DEPARTMENT: {
    fullPath: `${PROGRAM_BASE_PATH}/department/:id`,
    path: 'department/:id',
    name: 'department'
  },
  ANNUAL_REPORTS: {
    fullPath: `${PROGRAM_BASE_PATH}/annualreports`,
    path: 'annualreports',
    name: 'programannualreports'
  },
  HCES: {
    fullPath: `${PROGRAM_BASE_PATH}/hces`,
    path: 'hces',
    name: 'programHces'
  },
  EDIT_TRANSACTION: {
    fullPath: `${PROGRAM_BASE_PATH}/transaction/:id`,
    path: 'transaction/:id',
    name: 'edittransaction'
  },
  REPORTING_EXCEPTIONS: {
    fullPath: `${PROGRAM_BASE_PATH}/reportingexceptions`,
    path: 'reportingexceptions',
    name: 'reportingexceptions'
  },
  REPORTING_EXCEPTION_RESPONSE: {
    fullPath: `${PROGRAM_BASE_PATH}/reportingexception/response`,
    path: 'reportingexception/response',
    name: 'reportingexceptionresponse'
  },
  REPORTING_EXCEPTION_ADDITIONAL_TIME: {
    fullPath: `${PROGRAM_BASE_PATH}/reportingexception/response/additionaltime`,
    path: 'reportingexception/response/additionaltime',
    name: 'reportingexceptionadditionaltimeresponse'
  }
};